import { Component, OnInit, EventEmitter } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { PackageService } from '../../common/package.service';

@Component({
  selector: 'feature-limit-form',
  templateUrl: './feature-limit-form.component.html',
  styleUrls: ['./feature-limit-form.component.css', '../../app.component.css'],
  providers: [PackageService],
})
export class FeatureLimitFormComponent implements OnInit {

 eventId: any;
 packageId: any;
 featureId: any;
 featureLimitForm: any;
 featureLimitId: any;
 featureLimit: any;
 features: any;
 spinner : boolean = false;

 constructor(private formBuilder: FormBuilder, private packageService: PackageService, private activatedRoute: ActivatedRoute){
  this.featureLimitForm = this.formBuilder.group({
   'id': [''],
   'featureId': ['', Validators.required],
   'free': ['', Validators.required],
  });
  this.featureLimit = this.featureLimitForm.value;
 }

 ngOnInit() {
 }

 onSave = new EventEmitter();

 saveFeatureLimit() {
  if(this.featureLimitForm.valid)
  {
   this.spinner = true;
   var params = this.featureLimitForm.value;
   params.packageId = this.packageId;
   this.packageService.saveFeatureLimit(params).subscribe(
    response => {
     this.spinner = false;
     if(response.status)
     this.onSave.emit();
    },
    error => {
     this.spinner = false;
    }
   );
  }
 }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/feature-limit-form/feature-limit-form.component.ts